export const ROOM_TYPE_OPTIONS = [
  { value: 'air', label: 'air' },
  { value: 'fan', label: 'fan' },
  { value: 'standard', label: 'standard' },
] as const

export const ROOM_STATUS_OPTIONS = [
  { value: 'occupied', label: 'occupied' },
  { value: 'available', label: 'available' },
  { value: 'under_renovation', label: 'under renovation' },
  { value: 'not_available', label: 'not available' },
] as const
